import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

type PostCommand = Database['public']['Tables']['sub_topics']['Insert'];

async function postSubTopic(command: PostCommand) {
  const { data, error } = await apiClient
    .from('sub_topics')
    .insert(command)
    .select('id')
    .single();

  if (error) {
    throw error
  }

  return data;
}

export function usePostSubTopic(topicId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (command: PostCommand) => postSubTopic(command),
    onSuccess: () => {
      enqueueSnackbar('Sous-sujet créé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.subTopicListByTopicId(topicId) })
    }
  })
}
